import type { FlowPhase } from "@patient-watch/ui";
import { create } from "zustand";

import type { JourneyPhaseKey, JourneyTodos, PatientNotificationCounts } from "../journeyTodos";
import type { NextJourneyPhase } from "../utils/getNextJourneyPhase";

export interface PatientJourneySnapshot {
    diaryId: string | null;
    todos: JourneyTodos;
    phases: FlowPhase[];
    setupApplicable: boolean;
    allPhasesComplete: boolean;
    outstandingCount: number;
    todoCounts: Record<JourneyPhaseKey, number>;
    notifications: PatientNotificationCounts | null;
    nextStage: NextJourneyPhase | null;
}

interface PatientJourneyStore {
    snapshot: PatientJourneySnapshot | null;
    setSnapshot: (snapshot: PatientJourneySnapshot | null) => void;
}

export const usePatientJourneyStore = create<PatientJourneyStore>((set) => ({
    snapshot: null,
    setSnapshot: (snapshot) => set({ snapshot }),
}));
